<template>
  <div class="circuitQuery mainPageBg">
    <div class="selectBox ashComWrap">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="设备">
          <el-cascader
            v-model="formInline.equipment"
            :options="options"
            :show-all-levels="false"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="formInline.date"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="间隔时长">
          <el-select v-model="formInline.time">
            <el-option label="五分钟" value="五分钟"></el-option>
            <el-option label="十分钟" value="十分钟"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="contentBox ashComWrap">
      <el-table
        :data="tableData"
        height="97%"
        border
        stripe
        size="small"
        style="width: 95%; margin: 10px auto"
        :header-cell-style="{
          'font-weight': 'bold',
          color: '#333',
          'background-color': '#F7F7F7',
        }"
      >
        <el-table-column
          v-for="(v, i) in tableHeader"
          :key="i"
          :prop="v.prop"
          :label="v.label"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formInline: {
        equipment: ["配电房1", "变压器1", "P04", "1回路1"],
        date: new Date(),
        time: "五分钟",
      },
      options: [
        {
          value: "配电房1",
          label: "配电房1",
          children: [
            {
              value: "变压器1",
              label: "变压器1",
              children: [
                {
                  value: "P04",
                  label: "P04",
                  children: [
                    { value: "1回路1", label: "回路1" },
                    { value: "光伏回路", label: "光伏回路" },
                    { value: "1回路3", label: "回路3" },
                  ],
                },
                { value: "P05", label: "P05" },
                { value: "P06", label: "P06" },
              ],
            },
            {
              value: "变压器2",
              label: "变压器2",
              children: [
                { value: "2回路1", label: "回路1" },
                { value: "2回路2", label: "回路2" },
                { value: "2回路3", label: "回路3" },
              ],
            },
          ],
        },
        {
          value: "配电房2",
          label: "配电房2",
          children: [
            {
              value: "1变压器1",
              label: "变压器1",
              children: [
                { value: "11回路1", label: "回路1" },
                { value: "11回路2", label: "回路2" },
              ],
            },
          ],
        },
      ],
      tableData: [
        {
          name: "AA101",
          time: "00:10",
          load: 0,
          la: 0,
          lb: 0,
          lc: 0,
          Uab: 0,
          Ubc: 0,
          Uca: 0,
          P: 0,
          PE: 0,
          EA: 0,
        },
      ],
      tableHeader: [],
    };
  },
  methods: {
    onSubmit() {},
    handleChange(value) {
      // console.log(value);
      this.getTabData();
    },
    getTabData() {
      this.tableHeader = [];
      this.tableData = [];
      if (this.formInline.equipment[3] == "光伏回路") {
        this.tableHeader = [
          { prop: "name", label: "回路名称" },
          { prop: "time", label: "采集时间" },
          { prop: "photovoltaic", label: "光伏" },
          { prop: "electricity", label: "发电" },
          { prop: "la", label: "la(A)" },
          { prop: "lb", label: "lb(A)" },
          { prop: "lc", label: "lc(A)" },
          { prop: "Uab", label: "Uab(V)" },
          { prop: "Ubc", label: "Ubc(V)" },
          { prop: "Uca", label: "Uca(V)" },
          { prop: "P", label: "P(kW)" },
          { prop: "PE", label: "PE" },
          { prop: "EA", label: "EA(kW)" },
        ];
        this.tableData = [
          {
            name: "AA101",
            time: "00:20",
            photovoltaic: 0,
            electricity: 0,
            la: 0,
            lb: 0,
            lc: 0,
            Uab: 0,
            Ubc: 0,
            Uca: 0,
            P: 0,
            PE: 0,
            EA: 0,
          },
        ];
      } else {
        this.tableHeader = [
          { prop: "name", label: "回路名称" },
          { prop: "time", label: "采集时间" },
          { prop: "load", label: "负载率" },
          { prop: "la", label: "la(A)" },
          { prop: "lb", label: "lb(A)" },
          { prop: "lc", label: "lc(A)" },
          { prop: "Uab", label: "Uab(V)" },
          { prop: "Ubc", label: "Ubc(V)" },
          { prop: "Uca", label: "Uca(V)" },
          { prop: "P", label: "P(kW)" },
          { prop: "PE", label: "PE" },
          { prop: "EA", label: "EA(kW)" },
        ];
        this.tableData = [
          {
            name: "AA101",
            time: "00:10",
            load: 0,
            la: 0,
            lb: 0,
            lc: 0,
            Uab: 0,
            Ubc: 0,
            Uca: 0,
            P: 0,
            PE: 0,
            EA: 0,
          },
          {
            name: "AA101",
            time: "00:15",
            load: 0,
            la: 0,
            lb: 0,
            lc: 0,
            Uab: 0,
            Ubc: 0,
            Uca: 0,
            P: 0,
            PE: 0,
            EA: 0,
          },
          {
            name: "AA101",
            time: "00:20",
            load: 0,
            la: 0,
            lb: 0,
            lc: 0,
            Uab: 0,
            Ubc: 0,
            Uca: 0,
            P: 0,
            PE: 0,
            EA: 0,
          },
          {
            name: "AA101",
            time: "00:25",
            load: 0,
            la: 0,
            lb: 0,
            lc: 0,
            Uab: 0,
            Ubc: 0,
            Uca: 0,
            P: 0,
            PE: 0,
            EA: 0,
          },
          {
            name: "AA101",
            time: "00:30",
            load: 0,
            la: 0,
            lb: 0,
            lc: 0,
            Uab: 0,
            Ubc: 0,
            Uca: 0,
            P: 0,
            PE: 0,
            EA: 0,
          },
        ];
      }
    },
  },
  created() {
    this.getTabData();
  },
};
</script>

<style lang="scss" scoped>
.circuitQuery {
  @include setFlexColumn;
  justify-content: center;
  align-items: center;
  .selectBox {
    width: 96%;
    height: 10%;
    @include setFlexStart;
    ::v-deep .el-form {
      margin-left: 20px;
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
  .contentBox {
    margin-top: 1%;
    width: 96%;
    height: 83%;
  }
}
</style>